import { Address } from './address.model';
import { FeatureStage } from './company.model';
import { UserRole } from './user.model';

export type CompanyInvestorVisibility = 'PUBLIC' | 'NONE';

export const USER_STATUS_ACTIVE = 1;
export const USER_STATUS_INACTIVE = 900;

export const ROLE_LABELS: Partial<Record<UserRole, string>> = {
  [UserRole.OWNER]: 'PTL_ROLE_OWNER',
  [UserRole.ADMIN]: 'PTL_ROLE_ADMIN',
  [UserRole.RESTRICTED]: 'PTL_ROLE_RESTRICTED',
  [UserRole.VIEWER]: 'PTL_ROLE_VIEWER',
  [UserRole.OPERATIONS]: 'PTL_ROLE_OPERATIONS',
  [UserRole.EXECUTIVE]: 'PTL_ROLE_EXECUTIVE',
};

export interface OrganizationDomain {
  _id: string;
  domain: string;
}

export interface OrganizationDetails {
  _id: string;
  companyName: string;
  address?: Address;
  currency: string;
  language: string;
  logoImage: string;
  licenseInstance: OrganizationLicenseState;
  companyType: string;
  staff: OrganizationStaffMember[];
  timezone: string;
  url?: string;
  testOrganizationFlag?: boolean;
  investorVisibility?: CompanyInvestorVisibility;
  domains?: OrganizationDomain[];
  featureStage?: FeatureStage;
}

export interface OrganizationLicenseState {
  _id?: string;
  licenseTemplateName: string;
  roles: UserRole[];
  firstUserRole: UserRole;
  productLevel: number;
  description?: string;
}

export interface OrganizationStaffMember {
  [x: string]: any;
  _id: string;
  role?: UserRole;
  roleName?: string;
  status?: number;
  userFlag?: number;
  personApi?: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    avatarDocId?: string;
  };
  email: string;
}

export interface OrganizationLicenseData {
  _id: string;
  licenseTemplateName: string;
  description: string;
  productLevel: number;
  firstUserRole: UserRole;
  features: string[];
  productList: Product[];
  roles: UserRole[];
}

interface Product {
  logo: string;
  name: string;
  schema: string;
}

export interface OrganizationScopes {
  roles: {
    par: number;
  };
  e: number[];
}

export interface OrganizationLicenseUpdatePayload {
  customer: string;
  productLevel: number;
}
